import { createClient } from '@supabase/supabase-js';
import { dbKeys } from '../constant';


// Initialize Supabase Client
const SUPABASE_URL = process.env.REACT_APP_API_URL; // Replace with your Supabase URL
const SUPABASE_KEY = process.env.REACT_APP_API_KEY; // Replace with your Supabase API Key
const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

// Helper Functions
const SupabaseService = {
  // Fetch all data from a table
  fetchData: async (tableName) => {
    const { data, error } = await supabase.from(tableName).select('*');
    if (error) throw new Error(`Error fetching data: ${error.message}`);
    return data;
  },
  getData: async (tableName, page = 1, limit = 6, filters,id) => {
    const start = (page - 1) * limit;
    const end = start + limit - 1;
    let walkin
    let query = supabase
      .from(tableName)
      .select('*', { count: 'exact' })
      .order('created_at', { ascending: false })
      .range(start, end)
    // Fetch data by specific ID
    if (id) {

     const  {data} = await supabase
        .from(tableName)
        .select('*')
        .eq('id', id);
        walkin=data[0]

    } 
      // Apply other filters if ID is not present
      if (filters?.[dbKeys.job_title]) {
        const terms =filters?.[dbKeys.job_title].split(' ').map(term => `%${term}%`);
        terms.forEach(term => {
          query = query.or(
            `${dbKeys.job_location}.ilike.${term},${dbKeys.job_title}.ilike.${term},${dbKeys.employer_name}.ilike.${term},${dbKeys.job_description}.ilike.${term}`
          );
        });
      }
      if (filters?.[dbKeys.job_location]) {
        const terms = filters?.[dbKeys.job_location].split(',').map(term => term.trim());
        const filterString = terms
          .map(term => (term !== '' ? `${dbKeys.job_location}.ilike.%${term}%` : ''))
          .filter(Boolean)
          .join(',');
        query = query.or(filterString);
      }
      if (filters?.[dbKeys.job_employment_type]) {
        const terms = filters?.[dbKeys.job_employment_type].split(',').map(term => term.trim());
        const filterString = terms
          .map(term => (term !== '' ? `${dbKeys.job_employment_type}.ilike.%${term}%` : ''))
          .filter(Boolean)
          .join(',');
        query = query.or(filterString);
      }
      if (filters?.industry) {
        query = query.ilike('industry', `%${filters.industry}%`);
      }
    query.eq("status",true)
  
    // Execute query
    const { data, count, error } = await query;
    if (error) {
      console.error('Error fetching data:', error);
      return { data: [], total: 0 };
    }
  
    return {walkin:walkin || {}, data: data || [], total: count || 0 };
  },
  
  // Insert data into a table
  insertData: async (tableName, rowData) => {
    const { data, error } = await supabase.from(tableName).insert(rowData);
    if (error) throw new Error(`Error inserting data: ${error.message}`);
    return data;
  },

  // Sign up a new user
  signUp: async (email, password) => {
    const { user, error } = await supabase.auth.signUp({
      email,
      password,
    });
    if (error) throw new Error(`Sign up failed: ${error.message}`);
    return user;
  },

  // Log in an existing user
  logIn: async (email, password) => {
    const { user, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) throw new Error(`Login failed: ${error.message}`);
    return user;
  },

  // Log out the current user
  logOut: async () => {
    const { error } = await supabase.auth.signOut();
    if (error) throw new Error(`Logout failed: ${error.message}`);
    return true;
  },

  // Subscribe to real-time changes on a table
  subscribeToTable: (tableName, callback) => {
    const subscription = supabase
      .channel('table_changes')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: tableName },
        callback
      )
      .subscribe();

    return subscription;
  },

  // Remove a subscription
  unsubscribe: (subscription) => {
    supabase.removeChannel(subscription);
  },
fetchActiveFilters : async (rpc) => {
    // Define filter headings and their corresponding column names
    const filterColumns = {
      "Job Type": "job_employment_type",
      "Location": "job_location",
    };
  
  
    for (const [heading] of Object.entries(filterColumns)) {
      const { data, error } = await supabase.rpc(rpc)
      if (error) {
        console.error(`Error fetching ${heading} filters:`, error);
        continue;
      }
      return data;
      // Transform data into the desired format
    }
 
  }
};

export default SupabaseService;
